export enum NotificationType {
    basket = 0,
    claim = 1,
    basketTxml5 = 2
}
